import React from "react";

const ImageModalViewer = ({ show, handleClose, imageUrl, fileName = "Image" }) => {
  if (!show) return null;

  return (
    <div
      className="fixed inset-0 z-[10001] bg-black/80 backdrop-blur-sm flex items-center justify-center p-4"
      onClick={handleClose}
    >
      <div
        className="relative max-w-4xl max-h-[90vh] bg-black rounded-lg shadow-2xl flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-gray-700">
          <span className="text-white font-semibold truncate text-sm">{fileName}</span>
          <button
            onClick={handleClose}
            className="text-gray-400 hover:text-white transition-colors text-xl font-bold"
          >
            ✕
          </button>
        </div>

        {/* Image Container */}
        <div className="flex-1 flex items-center justify-center overflow-auto min-h-0">
          <img
            src={imageUrl}
            alt={fileName}
            className="max-w-full max-h-full object-contain"
            onError={(e) => {
              e.target.style.display = "none";
              const errorDiv = document.createElement("div");
              errorDiv.className = "text-gray-400 text-center";
              errorDiv.textContent = "Failed to load image";
              e.target.parentNode.appendChild(errorDiv);
            }}
          />
        </div>

        {/* Footer with Controls */}
        <div className="flex items-center justify-between p-4 border-t border-gray-700 bg-gray-900">
          <span className="text-gray-400 text-xs">{fileName}</span>
          <div className="flex gap-3">
            <button
              onClick={(e) => {
                e.stopPropagation();
                try {
                  // Since imageUrl is already proxied, we just append download=true
                  const downloadUrl = `${imageUrl}&download=true&fileName=${encodeURIComponent(fileName)}`;
                  const link = document.createElement("a");
                  link.href = downloadUrl;
                  // We still set this, but backend Content-Disposition will take precedence
                  link.download = fileName;
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                } catch (error) {
                  console.error("Download failed:", error);
                  window.open(imageUrl, "_blank");
                }
              }}
              className="px-4 py-2 bg-primaryColor hover:bg-darkPrimaryColor text-white rounded text-sm font-medium transition-colors"
            >
              Download
            </button>
            <button
              onClick={handleClose}
              className="px-4 py-2 bg-gray-700 hover:bg-gray-600 text-white rounded text-sm font-medium transition-colors"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImageModalViewer;
